import React from 'react';
import { FaTimes, FaCheckCircle, FaTimesCircle, FaBuilding, FaEnvelope, FaMapMarkerAlt, FaUser, FaFileContract } from 'react-icons/fa';

function ApplicationDetailModal({ application, onClose, onApprove, onReject }) {
  const app = application;
  const isChain = app.is_chain === true;

  const formatDate = (date) => {
    if (!date) return '—';
    return new Date(date).toLocaleString('az-AZ', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  };

  return (
    <>
      <div style={styles.overlay} onClick={onClose} />
      <div style={styles.modal}>

        {/* Header */}
        <div style={styles.header}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
              <h2 style={styles.title}>📝 Müraciət Detallı</h2>
              <span style={{
                padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700,
                background: isChain ? '#EDE9FE' : '#FFF7E6',
                color: isChain ? '#6D28D9' : '#92400E',
              }}>
                {isChain ? '🏢 Filial Şəbəkəsi' : '☕ Tək Kafe'}
              </span>
              {app.contract_accepted && (
                <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700, background: '#E8F5E9', color: '#2E7D32' }}>
                  ✅ Müqavilə qəbul edilib
                </span>
              )}
            </div>
            <p style={styles.subtitle}>{app.company_name}</p>
          </div>
          <button onClick={onClose} style={styles.closeBtn}><FaTimes size={20} /></button>
        </div>

        <div style={styles.content}>

          {/* ── SINGLE CAFE ──────────────────────────────────────── */}
          {!isChain && (
            <>
              <Section title={<><FaBuilding /> Kafe Məlumatları</>}>
                <InfoItem label="Kafenin Adı"   value={app.company_name} />
                <InfoItem label="Biznes Növü"   value={app.business_type} />
                {app.cuisine_type  && <InfoItem label="Mətbəx Növü" value={app.cuisine_type} />}
                {app.working_hours && <InfoItem label="İş Saatları" value={app.working_hours} />}
                {app.capacity      && <InfoItem label="Tutum"       value={`${app.capacity} yer`} />}
              </Section>

              <Section title={<><FaMapMarkerAlt /> Ünvan</>}>
                <InfoItem label="Ünvan"   value={app.address} />
                <InfoItem label="Şəhər"   value={app.city} />
                <InfoItem label="Telefon" value={app.phone} />
              </Section>

              <Section title={<><FaUser /> Sahibi</>}>
                <InfoItem label="Ad Soyad" value={app.representative_name} />
                <InfoItem label="Telefon"  value={app.representative_phone} />
                <InfoItem label="VÖEN"     value={app.voen} isVoen />
                {app.license_number && <InfoItem label="Lisenziya №" value={app.license_number} />}
                <LicenseDoc url={app.license_document_url} />
              </Section>
            </>
          )}

          {/* ── CHAIN ────────────────────────────────────────────── */}
          {isChain && (
            <>
              <Section title={<><FaBuilding /> Hüquqi Məlumatlar</>}>
                <InfoItem label="Şirkətin Adı" value={app.company_name} />
                <InfoItem label="Hüquqi Ad"    value={app.legal_name} />
                <InfoItem label="VÖEN"         value={app.voen} isVoen />
                {app.license_number && <InfoItem label="Lisenziya №" value={app.license_number} />}
                <LicenseDoc url={app.license_document_url} />
              </Section>

              <Section title={<><FaUser /> Sahibin Kimliyi</>}>
                <InfoItem label="Ad Soyad"       value={app.representative_name} />
                <InfoItem label="Vəzifə"          value={app.representative_position} />
                <InfoItem label="Telefon"         value={app.representative_phone} />
                {app.representative_id_number && (
                  <InfoItem label="Şəxsiyyət vəsiqəsi №" value={app.representative_id_number} />
                )}
              </Section>
            </>
          )}

          {/* ── LOGIN EMAIL (both) ────────────────────────────────── */}
          <Section title={<><FaEnvelope /> Giriş Məlumatları</>}>
            <InfoItem label="Email" value={app.email} />
          </Section>

          {/* ── CONTRACT ─────────────────────────────────────────── */}
          <Section title={<><FaFileContract /> Müqavilə</>}>
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Online Qəbul:</span>
              {app.contract_accepted ? (
                <span style={{ color: '#2E7D32', fontWeight: 700, fontSize: 14 }}>✅ Qəbul edilib</span>
              ) : (
                <span style={{ color: '#C62828', fontWeight: 700, fontSize: 14 }}>❌ Qəbul edilməyib</span>
              )}
            </div>
            {app.contract_accepted_at && (
              <InfoItem label="Qəbul Tarixi" value={formatDate(app.contract_accepted_at)} />
            )}
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>İslaq İmza:</span>
              <span style={{ fontSize: 13, color: '#888' }}>Təsdiqləndikdən sonra göndəriləcək</span>
            </div>
          </Section>

          {/* ── APPLICATION META ─────────────────────────────────── */}
          <Section title="📋 Müraciət Məlumatları">
            <InfoItem label="Müraciət Tarixi" value={formatDate(app.created_at)} />
            <div style={styles.infoItem}>
              <span style={styles.infoLabel}>Status:</span>
              <StatusBadge status={app.status} />
            </div>
            {app.reviewed_at && <InfoItem label="Baxılma Tarixi" value={formatDate(app.reviewed_at)} />}
            {app.rejection_reason && (
              <div style={{ ...styles.infoItem, gridColumn: '1 / -1' }}>
                <span style={styles.infoLabel}>Rədd Səbəbi:</span>
                <p style={styles.rejectionReason}>{app.rejection_reason}</p>
              </div>
            )}
          </Section>
        </div>

        {/* Actions */}
        {app.status === 'pending' && (
          <div style={styles.footer}>
            <button onClick={onReject} style={styles.btnReject}><FaTimesCircle /> Rədd Et</button>
            <button onClick={onApprove} style={styles.btnApprove}><FaCheckCircle /> Təsdiqlə</button>
          </div>
        )}
      </div>
    </>
  );
}

// ── Helpers ──────────────────────────────────────────────────────────────────

function Section({ title, children }) {
  return (
    <div style={styles.section}>
      <h3 style={styles.sectionTitle}>{title}</h3>
      <div style={styles.infoGrid}>{children}</div>
    </div>
  );
}

const InfoItem = ({ label, value, isVoen }) => (
  <div style={styles.infoItem}>
    <span style={styles.infoLabel}>{label}:</span>
    {isVoen ? (
      <span style={styles.voenBadge}>{value || '—'}</span>
    ) : (
      <span style={styles.infoValue}>{value || '—'}</span>
    )}
  </div>
);

const LicenseDoc = ({ url }) => (
  <div style={{ ...styles.infoItem, gridColumn: '1 / -1' }}>
    <span style={styles.infoLabel}>Lisenziya Sənədi:</span>
    {url ? (
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginTop: 4, flexWrap: 'wrap' }}>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '10px 18px', borderRadius: 10,
            background: 'linear-gradient(135deg, #1565C0, #1976D2)',
            color: '#fff', fontSize: 14, fontWeight: 700,
            textDecoration: 'none',
          }}
        >
          📄 Sənədə Bax / Yüklə
        </a>
        {url.match(/\.(jpg|jpeg|png)$/i) && (
          <img
            src={url}
            alt="Lisenziya"
            style={{ maxHeight: 120, borderRadius: 8, border: '1px solid #E0E0E0', marginTop: 6 }}
          />
        )}
      </div>
    ) : (
      <span style={{
        display: 'inline-block', marginTop: 4, padding: '6px 12px',
        borderRadius: 8, background: '#FFEBEE', color: '#C62828',
        fontSize: 13, fontWeight: 600,
      }}>
        ⚠️ Sənəd yüklənməyib
      </span>
    )}
  </div>
);

const StatusBadge = ({ status }) => {
  const map = {
    approved: { bg: '#E8F5E9', color: '#2E7D32', text: 'Təsdiqlənmiş' },
    rejected: { bg: '#FFEBEE', color: '#C62828', text: 'Rədd edilmiş' },
    pending:  { bg: '#FFF3E0', color: '#F57C00', text: 'Gözləyən' },
  };
  const s = map[status] || map.pending;
  return (
    <span style={{ ...styles.statusBadge, backgroundColor: s.bg, color: s.color }}>
      {s.text}
    </span>
  );
};

// ── Styles ───────────────────────────────────────────────────────────────────
const styles = {
  overlay: { position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 2000 },
  modal: {
    position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff', borderRadius: 16,
    width: '95%', maxWidth: 900, maxHeight: '90vh', overflowY: 'auto',
    zIndex: 2001, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  header: {
    padding: '24px 28px', borderBottom: '2px solid #F0F0F0',
    display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
    position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1,
  },
  title: { fontSize: 22, fontWeight: 'bold', color: '#1A1A2E', margin: 0 },
  subtitle: { fontSize: 14, color: '#666', margin: 0 },
  closeBtn: {
    backgroundColor: '#F44336', color: '#fff', border: 'none',
    borderRadius: '50%', width: 36, height: 36,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer',
  },
  content: { padding: '24px 28px' },
  section: { marginBottom: 28 },
  sectionTitle: {
    fontSize: 16, fontWeight: 'bold', color: '#1A1A2E',
    marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8,
  },
  infoGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 },
  infoItem: { display: 'flex', flexDirection: 'column', gap: 4 },
  infoLabel: { fontSize: 11, color: '#999', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.3px' },
  infoValue: { fontSize: 14, color: '#1A1A2E', fontWeight: 500 },
  voenBadge: {
    fontFamily: 'monospace', fontSize: 14,
    backgroundColor: '#F8F9FA', padding: '5px 10px',
    borderRadius: 6, color: '#444', fontWeight: 'bold', display: 'inline-block',
  },
  link: { fontSize: 14, color: '#2196F3', textDecoration: 'underline' },
  statusBadge: {
    display: 'inline-block', padding: '5px 12px',
    borderRadius: 20, fontSize: 13, fontWeight: 600,
  },
  rejectionReason: {
    fontSize: 14, color: '#C62828', backgroundColor: '#FFEBEE',
    padding: 12, borderRadius: 8, margin: 0,
  },
  footer: {
    padding: '18px 28px', borderTop: '2px solid #F0F0F0',
    display: 'flex', gap: 12, justifyContent: 'flex-end',
    position: 'sticky', bottom: 0, backgroundColor: '#fff',
  },
  btnApprove: {
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '11px 22px', backgroundColor: '#4CAF50',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 14, fontWeight: 600, cursor: 'pointer',
  },
  btnReject: {
    display: 'flex', alignItems: 'center', gap: 8,
    padding: '11px 22px', backgroundColor: '#F44336',
    color: '#fff', border: 'none', borderRadius: 8,
    fontSize: 14, fontWeight: 600, cursor: 'pointer',
  },
};

export default ApplicationDetailModal;
